module.exports = __webpack_public_path__ + "img/bsignup-continue-3.fad9830d.png";